import TeacherDetailsInfo from "../../../../utils/TeacherDetailsInfo";
import LocationCode from "../../../../utils/constants/LocationCode";
import TeacherConstant from "../../../../utils/constants/TeacherConstant";
import Gender from "../../../../utils/constants/Gender";
import "../../../../css/modal/ModalInput.css"
import "../../../../css/modal/TeacherManagementModal.css";
import {
    checkValidDateElementWithPattern,
    getDateString,
    limitInputNumber,
    moveModal,
    setInvalidMessage
} from "../../../../utils/Utils";
import { useState } from "react";
import proxy from "../../../../utils/Proxy";

let TeacherRegisterModal = (props) => {
    let [submitted, setSubmitted] = useState(false);

    let info = TeacherDetailsInfo;

    let onPasswordChange = (e) => {
        let passwordConfirm = document.querySelector('input[name="teacher-details-password_confirm"]');
        passwordConfirm.pattern = e.target.value;
        let message = TeacherDetailsInfo.invalidMessages["PASSWORD_NOT_MATCHES"]
        if (passwordConfirm.validity.valid)
            setInvalidMessage(passwordConfirm, "teacher-details-invalid-password_confirm", message);
    }

    let getRadios = (dataName, inputName, inputData) => {
        let ret = [];
        for (let dataId in inputData) {
            let key = inputName + ":" + dataId;
            let invalidMessageId = TeacherDetailsInfo.getInvalidMessageId(dataName);
            ret.push(
                <label className="modal-input-radio-label" key={key}>
                    <input type="radio"
                        name={inputName}
                        value={parseInt(dataId)}
                        onChange={() => {
                            document.getElementById(invalidMessageId).innerHTML = "";
                        }}
                        required />
                    <p>{inputData[dataId]}</p>
                </label>
            )
        }
        return <div className="modal-input-radio-container">{ret}</div>;
    }
    let save = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (!dialogResult) return;

        setSubmitted(true);

        let invalidList = [];
        let requestData = {};
        for (let i = 0; i < TeacherDetailsInfo.registerInputs.length; i++) {
            let dataName = TeacherDetailsInfo.registerInputs[i];
            let dataLabel = TeacherDetailsInfo.registerInputLabels[i];
            let inputName = TeacherDetailsInfo.getInputName(dataName);
            let invalidMessageId = TeacherDetailsInfo.getInvalidMessageId(dataName);
            if (dataName === "location" || dataName === "major" || dataName === "gender") {
                let checkedTarget = document.querySelector('input[name="' + inputName + '"]:checked');
                if (checkedTarget === null || checkedTarget.value === null) {
                    invalidList.push(dataLabel)
                    let targetRadio = document.querySelector('input[name="' + inputName + '"]');
                    setInvalidMessage(targetRadio, invalidMessageId,
                        TeacherDetailsInfo.invalidMessages[TeacherDetailsInfo.registerInvalid[i]])
                    continue;
                } else {
                    requestData[dataName] = parseInt(checkedTarget.value);
                }
            }
            if (dataName === "birth" || dataName === "registration") {
                if (!checkValidDate(dataName))
                    invalidList.push(dataLabel)
                continue;
            }
            let validityTarget = document.querySelector('input[name="' + inputName + '"]')
            if (!validityTarget.validity.valid) {
                invalidList.push(dataLabel);
                setInvalidMessage(validityTarget, invalidMessageId,
                    TeacherDetailsInfo.invalidMessages[TeacherDetailsInfo.registerInvalid[i]])
            }
        }
        if (invalidList.length > 0) {
            let message = ""
            for (let invalid of invalidList)
                message += invalid + ", ";
            message = message.slice(0, -2);
            window.alert("잘못된 형식입니다.\n(" + message + ")");
            return;
        }
        for (let i = 0; i < TeacherDetailsInfo.registerInputs.length; i++) {
            let dataName = TeacherDetailsInfo.registerInputs[i];
            let inputName = TeacherDetailsInfo.getInputName(dataName);
            if (TeacherDetailsInfo.registerRadioInputs.indexOf(dataName) !== -1) {
                continue;
            }
            let element = document.querySelector('input[name="' + inputName + '"]')
            switch (dataName) {
                case "birth":
                    let year = document.querySelector('input[name="' + inputName + '-year"]').value
                    let month = document.querySelector('input[name="' + inputName + '-month"]').value
                    let date = document.querySelector('input[name="' + inputName + '-date"]').value

                    let birth = new Date(year, month - 1, date);
                    requestData[dataName] = getDateString(birth);
                    break;
                case "registration":
                    let ryear = document.querySelector('input[name="' + inputName + '-year"]').value
                    let rmonth = document.querySelector('input[name="' + inputName + '-month"]').value
                    let rdate = document.querySelector('input[name="' + inputName + '-date"]').value

                    let registration = new Date(ryear, rmonth - 1, rdate);
                    requestData[dataName] = getDateString(registration);
                    break;
                case "working_days":
                    requestData[dataName] = parseInt(element.value);
                    break;
                default:
                    requestData[dataName] = element.value;
            }
        }
        proxy.post("/adminapi/teachers", requestData).then(_ => {
            window.alert("강사 등록이 완료되었습니다.");
            setSubmitted(false);
            props.setNeedUpdate(true)
            props.setClosed();
        }).catch(res => {
            window.alert(res.response.data.message);
        })
    }
    let cancelRegister = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult) {
            setSubmitted(false)
            props.setClosed();
        }
    }
    let onDateChange = (e, len, key) => {
        limitInputNumber(e, len);
        checkValidDate(key);
    }
    let checkValidDate = (key) => {
        let year = document.querySelector('input[name="teacher-details-' + key + '-year"]')
        let month = document.querySelector('input[name="teacher-details-' + key + '-month"]')
        let date = document.querySelector('input[name="teacher-details-' + key + '-date"]')

        let valid = checkValidDateElementWithPattern(year, month, date);

        if (!valid) {
            document.getElementById("teacher-details-invalid-" + key).innerHTML
                = TeacherDetailsInfo.invalidMessages.INVALID_DATE;
            document.getElementById("teacher-details-" + key).className = "modal-input-invalid"
            return false;
        } else {
            document.getElementById("teacher-details-invalid-" + key).innerHTML = "";
            document.getElementById("teacher-details-" + key).className = "modal-input"
            return true;
        }
    }
    let getInputs = () => {
        let res = [];
        for (let index in info.registerInputs) {
            let dataName = info.registerInputs[index]

            let label = info.registerInputLabels[index]
            let inputName = info.getInputName(dataName);
            let invalidMessageId = info.getInvalidMessageId(dataName);
            let invalidMessage = info.invalidMessages[info.registerInvalid[index]]

            let key = inputName + index;
            let input;
            if (info.registerTextInputs.indexOf(dataName) !== -1) {
                let registerTextIndex = info.registerTextInputs.indexOf(dataName);
                let limit = info.registerTextInputLimits[registerTextIndex];
                input = (
                    <input
                        className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                        name={inputName}
                        onChange={(e) => {
                            setInvalidMessage(e.target, invalidMessageId, invalidMessage)
                            limitInputNumber(e, limit)
                            if (dataName === "password")
                                onPasswordChange(e)
                        }}
                        onBlur={(e) => {
                            setInvalidMessage(e.target, invalidMessageId, invalidMessage)
                        }}
                        pattern={info.registerTextRegex[registerTextIndex]}
                        type={dataName === "password" || dataName === "password_confirm" ? "password" : "text"}
                        required
                    />)
            } else if (info.registerRadioInputs.indexOf(dataName) !== -1) {
                switch (dataName) {
                    case "location":
                        input = getRadios(dataName, inputName, LocationCode.text)
                        break;
                    case "major":
                        input = getRadios(dataName, inputName, TeacherConstant.major_text)
                        break;
                    case "gender":
                        input = getRadios(dataName, inputName, Gender.text)
                        break;
                    default:
                        input = null;
                }
            } else if (dataName === "birth") {
                input = (
                    <div className={"modal-input"} id={inputName}>
                        <input className="modal-input-date" name={inputName + "-year"}
                            onChange={e => onDateChange(e, 4, "birth")}
                            onBlur={e => onDateChange(e, 4, "birth")}
                            pattern="\d{4}" required></input>
                        <p>-</p>
                        <input className="modal-input-date" name={inputName + "-month"}
                            onChange={e => onDateChange(e, 2, "birth")}
                            onBlur={e => onDateChange(e, 2, "birth")}
                            pattern="0?[1-9]|1[0-2]" required></input>
                        <p>-</p>
                        <input className="modal-input-date" name={inputName + "-date"}
                            onChange={e => onDateChange(e, 2, "birth")}
                            onBlur={e => onDateChange(e, 2, "birth")}
                            pattern="0?[1-9]|[1-2][0-9]|3[0-1]" required></input>
                    </div>
                )
            } else if (dataName === "registration") {
                let registration = new Date();
                let year = registration.getFullYear();
                let month = registration.getMonth() + 1;
                let date = registration.getDate();
                input = (
                    <div className={"modal-input"} id={inputName}>
                        <input className="modal-input-date" name={inputName + "-year"}
                            defaultValue={year} onChange={e => onDateChange(e, 4, "registration")}
                            onBlur={e => onDateChange(e, 4, "registration")}
                            pattern="\d{4}" required></input>
                        <p>-</p>
                        <input className="modal-input-date" name={inputName + "-month"}
                            defaultValue={month} onChange={e => onDateChange(e, 2, "registration")}
                            onBlur={e => onDateChange(e, 2, "registration")}
                            pattern="0?[1-9]|1[0-2]" required></input>
                        <p>-</p>
                        <input className="modal-input-date" name={inputName + "-date"}
                            defaultValue={date} onChange={e => onDateChange(e, 2, "registration")}
                            onBlur={e => onDateChange(e, 2, "registration")}
                            pattern="0?[1-9]|[1-2][0-9]|3[0-1]" required></input>
                    </div>
                )

            }
            res.push(<div className="modal-content-item modal-content-align-start" key={key}>
                <div className="modal-content-divider-2">
                    <p className="modal-content-text">{label}</p>
                </div>
                <div className="modal-content-divider-2">
                    {input}
                    <p className="modal-input-invalid-message" id={invalidMessageId}></p>
                </div>
            </div>)
        }
        return res;
    }
    return <div className="modal-container">
        <div className="modal" id="teacher-details-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "teacher-details-modal")}>
                    <p className="modal-title">
                        강사 등록
                    </p>
                    <div className="modal-close-button" onClick={() => props.setClosed()}>
                    </div>
                </div>
                <div className="modal-content">
                    {getInputs()}
                </div>
                <div className="modal-footer">
                    <div className="modal-footer-button-container">
                        <div className="modal-button" onClick={save}>
                            <p>저장</p>
                        </div>
                        <div className="modal-button" onClick={cancelRegister}>
                            <p>취소</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default TeacherRegisterModal